// In-app replacement for window.alert(): a message the user must acknowledge,
// rendered by <AlertHost /> (mounted once in App). Use it for errors the user
// has to act on; keep toasts (utils/toast) for minor, non-blocking feedback.

export interface AppAlert {
  message: string;
  title?: string;
  buttonText?: string;
  onClose?: () => void; // runs after the user dismisses the alert
}

type Listener = (alert: AppAlert) => void;
const listeners = new Set<Listener>();

/** Used by AlertHost; returns an unsubscribe function. */
export function subscribeAlerts(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function showAlert(message: string, options: Omit<AppAlert, "message"> = {}) {
  const alert: AppAlert = { message, ...options };
  if (listeners.size === 0) {
    // no host mounted (e.g. an isolated test or very early in boot)
    window.alert(message);
    alert.onClose?.();
    return;
  }
  listeners.forEach((listener) => listener(alert));
}
